import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gio-color-view',
  templateUrl: './color-view.component.html',
  styleUrls: ['./color-view.component.scss']
})
export class ColorViewComponent implements OnInit {

  @Input()
  color: string = '';

  @Input()
  size = '20'

  constructor() { }

  ngOnInit(): void {
  }

}
